import { getAgencyNeedsProfile } from "hiringagent-dashboard/actions/onboarding";
import { onboardingSliceSelector } from "hiringagent-dashboard/selectors";
import { createConnector } from "common/connectors/utils";

export default createConnector("WithHiringNeeds", onboardingSliceSelector, {
  onLoad: getAgencyNeedsProfile,
});
